import React, { PureComponent } from 'react'
import GatsbyLink from 'gatsby-link'
import TestimonialVideoCard from './VideoTestimonial'

import {
  CardWrapper,
  Image,
  Heading,
  Description,
  ReadMore
} from './styledComponents'

export default class Card extends PureComponent {
  render() {
    const {
      id,
      cardImgUrl,
      cardImgalt,
      isVideo,
      videoThumbnailUrl,
      videoAltText,
      videoId,
      heading,
      description,
      ReadmoreCta,
      ReadMoreURL
    } = this.props
    return (
      <CardWrapper>
        {isVideo ? (
          <TestimonialVideoCard
            id={id}
            videoThumbnailUrl={videoThumbnailUrl}
            // isVideoThumbnail
            videoAltText={videoAltText}
            videoId={videoId}
          />
        ) : (
          <Image
            id={id}
            dataSrc={cardImgUrl}
            alt={cardImgalt}
            className="lazyload"
          />
        )}

        <Heading as="h3">{heading}</Heading>
        <Description as="p" dangerouslySetInnerHTML={{ __html: description }} />
        <ReadMore id={`${id}ReadMore`} as={GatsbyLink} to={ReadMoreURL}>
          {ReadmoreCta}
        </ReadMore>
      </CardWrapper>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/ExperimentalMarketing/PortfolioSection/card.js